export default __webpack_public_path__ + "static/media/future.d234bc5f.svg";